import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles(() => ({
    wrapper: {
        position: 'relative',
        zIndex: 1000,
    },
    center: {
        position: 'absolute',
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 2,
    },
    background: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
        borderRadius: '4px'
    },
}));

export interface IBlockUIProps {
    loading: boolean,
    size?: number,
    color?: 'inherit' | 'primary' | 'secondary',
    children: React.ReactNode | React.ReactNode[]
}

export default function BlockUI(props: IBlockUIProps) {
    const {
        loading,
        size = 40,
        color = 'primary',
        children
    } = props;

    const classes = useStyles();

    return (
        <div className={classes.wrapper}>
            {loading && (
                <>
                    <div className={classes.center}>
                        <CircularProgress size={size} color={color}/>
                    </div>
                    <div className={classes.background}/>
                </>
            )}
            {children}
        </div>
    )
}